import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  spacing,
  radius,
  shadow,
  fontSize,
  fontWeight,
  fontFamily,
  screen,
  container
} from 'theme';

export const StyledWrapper = styled.div`
  width: 100%;
  padding: 0 ${spacing('md')};
  max-width: ${container('lg')};
  margin: 0 auto ${spacing('xl4')};
  background-color: ${color('midnight_100')};
`;

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};
  font-size: ${fontSize('md')};
  line-height: 1.5;
  margin: 0 auto ${spacing('md')};
  max-width: 58rem;

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
    margin-bottom: ${spacing('xl2')};
    text-align: center;
  }

  @media (max-width: ${screen('lgMax')}) {
    ${Heading2}::before {
      transform: unset;
      left: 0;
      height: ${spacing('xs2')};
    }
  }

  p:first-of-type {
    margin-top: 0;
  }

  p:last-of-type {
    margin-bottom: 0;
  }
`;

export const StyledFeatures = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('mdlg')};
  margin-top: ${spacing('xl')};
`;

export const StyledFeature = styled.div`
  background-color: ${color('white')};
  border-radius: ${radius('md')};
  padding: ${spacing('mdlg')};
  box-shadow: ${shadow('md')};
`;

export const StyledFeatureContent = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1);
  align-items: center;
  gap: ${spacing('md')};
  margin-top: ${spacing('md')};

  p {
    margin: 0;
    line-height: 1.5;
  }

  @media (min-width: ${screen('lg')}) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: ${spacing('xl2')};
  }
`;

export const StyledFeatureTitle = styled.h3`
  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('black')};
  line-height: 1.25;
  text-transform: uppercase;
  color: ${color('text_subtle')};
  letter-spacing: 0.35em;
  margin: 0;
`;

export const StyledFeatureStats = styled.div`
  display: flex;
  gap: ${spacing('md')};

  @media (min-width: ${screen('lg')}) {
    display: grid;
    grid-template-columns: minmax(0, max-content) auto minmax(0, 1fr);
    gap: ${spacing('xl')};
  }
`;

export const StyledFeatureFigure = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing('xs')};
  font-size: ${fontSize('md')};
  line-height: 1;
  text-transform: uppercase;
  font-weight: ${fontWeight('black')};

  @media (min-width: ${screen('md')}) {
    font-family: ${fontFamily('display')};
    font-size: ${fontSize('xl2')};
    font-weight: ${fontWeight('semiBold')};
  }

  svg {
    width: ${spacing('lg')};
    height: ${spacing('lg')};
  }

  &.high {
    svg {
      color: ${color('negative_500')};
    }
  }
  &.low {
    svg {
      color: ${color('positive_500')};
    }
  }
`;

export const StyledFeatureStat = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('sm')};
  align-items: flex-start;
`;

export const StyledFeatureArrow = styled.div`
  align-self: center;
  justify-self: center;

  svg {
    width: ${spacing('xl')};
    height: ${spacing('xl')};
    color: ${color('navy_500')};
  }
`;
